import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormattedMessage, FormattedHTMLMessage } from 'component-utilities/intl';

import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ModalButtons from '../ModalButtons';
import ModalContentCenter from '../ModalContentCenter';
import ModalText from '../ModalText';
import ModalInlineBanner from '../ModalInlineBanner';

export default function DeleteAssetErrorModal({ onClose }) {
    const BASE_KEY = 'components.modals.delete_asset_error';

    return (
        <ModalContainer>
            <ModalHeader withIcon type="warning" onCloseClick={onClose}>
                <FormattedMessage id={`${BASE_KEY}.title`} />
            </ModalHeader>

            <ModalInlineBanner type="warning">
                <FormattedMessage id={`${BASE_KEY}.warning`} />
            </ModalInlineBanner>

            <ModalContentCenter>
                <ModalText>
                    <FormattedHTMLMessage id={`${BASE_KEY}.content`} />
                </ModalText>
            </ModalContentCenter>

            <ModalButtons
                primaryText={<FormattedMessage id={`${BASE_KEY}.button`} />}
                onPrimaryClick={onClose}
            />
        </ModalContainer>
    );
}

DeleteAssetErrorModal.displayName = displayName('Modals/DeleteAssetErrorModal');

DeleteAssetErrorModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};
